// TODO make dynamic as two templates. Text-Ads & Image-Ads

export const soladsTemplateDataId = "solads-before-pagination-sol"

export const soladsBeforePaginationHtmlMobile = `<div id="page-bottom-sol" data-solads-id="${soladsTemplateDataId}"
    class="page-stripe page-stripe-page-bottom-sol  no-solads-label extra-top-spacing text-center">
    <div class="container">
        <div class="row-page-bottom-sol base-row row">
            <div class="sol-content relative text-center content-width-320">
                <div class="sol-advert-mark">
                    <span class="sol-label"><a href="http://www.solads.media/" target="_blank"
                            rel="nofollow">SolAds</a></span>
                    <small class="sol-text-label">Anzeige</small>
                </div>
                <div class="sol-frame sol-type-display" data-banner-free-type="ausblenden">
                    <script data-params="jsads">
                        m3ads_system = "Solads";
                        m3ads_partnernumber = 379946;
                        m3ads_subpartner = "m-ladies-bottom";
                        m3ads_numberadverts = 1;
                        m3ads_sectors = "2009";
                        m3ads_imagewidth = 320;
                        m3ads_imageheight = 100;
                    </script>
                </div>
                <div class="text-center banner-free-container ausblenden"><button class="btn btn-link ad-free-link"
                        role="link" type="button" data-toggle="modal" data-target="#banner-free-modal">
                        <span>Diese Werbung ausblenden</span>
                        <span class="icon icon-12 inline icon-remove-banner">
                            <svg data-icon-id="cross" viewBox="0 0 20 20"><path d="M.02 18.373 8.403 9.99.02 1.607 1.627 0l8.383 8.383L18.373.02l1.607 1.607-8.383 8.383 8.383 8.383L18.373 20 9.99 11.617 1.627 19.98z"></path></svg>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>`

export const soladsBeforePaginationHtmlPc = `<div class="solads-container" data-solads-id="${soladsTemplateDataId}">
    <div class="item clearfix text-left">
        <div class="sol-content relative col-xs-12 content-width-240">
            <div class="sol-advert-mark">
                <span class="sol-label"><a href="http://www.solads.media/" target="_blank"
                        rel="nofollow">SolAds</a></span>
                <small class="sol-text-label">Anzeigen</small>
            </div>
            <div class="sol-frame image-width-240 sol-text-1-row sol-type-text" data-columns="2">
                <script data-params="jsads">
                    m3ads_system = "Solads";
                    m3ads_partnernumber = 379946;
                    m3ads_subpartner = "ladies";
                    m3ads_numberadverts = 2;
                    m3ads_sectors = "2007";
                    m3ads_logoimagewidth = 240;
                    m3ads_logoimageheight = 120;
                </script>
            </div>
        </div>
    </div>
</div>`

export const soladsBottomPc = `<section
id="page-closing-sol"
class="page-stripe page-stripe-page-closing-sol white shadow"
>
<div class="container">
    <div class="row-page-closing-sol base-row row">
        <div class="sol-content relative content-width-728">
            <div class="sol-advert-mark">
                <span class="sol-label"><a href="http://www.solads.media/" target="_blank" rel="nofollow">SolAds</a></span>
                <small class="sol-text-label">Anzeige</small>
            </div>
            <div class="sol-frame sol-type-display display-height-xs-auto display-height-lg-90" data-banner-free-type="ausblenden" data-xs="{&quot;imageSize&quot;:{&quot;imageWidth&quot;:728,&quot;imageHeight&quot;:90}}" data-lg="{&quot;imageSize&quot;:{&quot;imageWidth&quot;:970,&quot;imageHeight&quot;:90}}">
                <script type="text/javascript" data-params="jsads">
                m3ads_system = "Solads";
                m3ads_partnernumber = 379946;
                m3ads_subpartner = "ladies";
                m3ads_numberadverts = 1;
                m3ads_notitle = true;
                            m3ads_sectors = "2009";
                                m3ads_imagewidth = 728;
                                m3ads_imageheight = 90;
                </script>
                </div>
                <div class="text-center banner-free-container ausblenden">
                    <button class="btn btn-link ad-free-link" role="link" type="button" data-toggle="modal" data-target="#banner-free-modal">
                        <span>Diese Werbung ausblenden</span>
                        <span class="icon icon-12 inline icon-remove-banner">
                            <svg data-icon-id="cross" viewBox="0 0 20 20"><path d="M.02 18.373 8.403 9.99.02 1.607 1.627 0l8.383 8.383L18.373.02l1.607 1.607-8.383 8.383 8.383 8.383L18.373 20 9.99 11.617 1.627 19.98z"/></svg>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>`
